import { useQuery } from '@tanstack/react-query'
import { getExternalTraining } from 'api/user/getExternalTraining'
import { userExternalTrainingKey } from './keys'

export function useUserExternalTraining(userId: number) {
  return useQuery({
    queryKey: userExternalTrainingKey(userId),
    queryFn: () => getExternalTraining(userId),
    enabled: !!userId,
  })
}
